/**
 * 格式化后端返回的服务器本地时间，避免 JS Date 时区换算导致显示偏移。
 * 直接提取 ISO / 空格分隔日期时间字符串中的年月日时分秒部分。
 */
export function formatServerDateTime(raw?: string | null): string {
  if (!raw) return '—';
  const normalized = String(raw).trim();
  const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}:\d{2})(?::(\d{2}))?/);
  if (match) {
    const year = Number(match[1]);
    if (!Number.isFinite(year) || year < 2000) return '—';
    const seconds = match[6] ?? '00';
    return `${match[1]}-${match[2]}-${match[3]} ${match[4]}:${match[5]}:${seconds}`;
  }
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime()) || d.getFullYear() < 2000) return '—';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export function formatJsonBlock(raw?: string | null): string {
  if (!raw) return '—';
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}

const RUN_STATUS_LABELS: Record<string, string> = {
  success: '成功',
  failed: '失败',
  skipped: '跳过',
  pending: '待执行',
  running: '执行中',
};

const RUN_SOURCE_LABELS: Record<string, string> = {
  manual_test: '手动测试',
  schedule_test: '排期测试',
  normal: '正式执行',
};

const TRIGGER_TYPE_LABELS: Record<string, string> = {
  api: '接口触发',
  mq: 'MQ触发',
};

export function formatRunStatus(raw?: string | null): string {
  if (!raw) return '—';
  return RUN_STATUS_LABELS[raw.toLowerCase()] ?? raw;
}

export function formatRunSource(raw?: string | null): string {
  if (!raw) return '—';
  return RUN_SOURCE_LABELS[raw.toLowerCase()] ?? raw;
}

export function formatTriggerType(raw?: string | null): string {
  if (!raw) return '—';
  return TRIGGER_TYPE_LABELS[raw.toLowerCase()] ?? raw;
}

export function pickSnakeCamel<T>(snake: T | undefined, camel: T | undefined): T | undefined {
  return camel ?? snake;
}
